var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-recaptcha',{attrs:{"sitekey":_vm.siteKey},on:{"verify":_vm.handleVerification}})}
var staticRenderFns = []

export { render, staticRenderFns }